import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { findById, findByIdAndUpdate } from '../../../actions/notificacao'
import { findById as findCondominioById } from '../../../actions/condominio'
import { find as findUnidadeByCondominioId } from '../../../actions/unidade'
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Icon, Form, Button } from 'semantic-ui-react';
import CamposNotificacao from './CamposNotificacao';
import { CabecalhoForm, RodapeForm } from '../../layouts/FormUI';
import Erro from '../../layouts/mensagens/Erro';
import * as FormValidator from "../../../utils/formValidator";

class EditarNotificacao extends Component {

  constructor(props) {
    super(props);

    this.state = {
      file: null,
      notificacao: props.notificacao,
      errors: {},
      sucesso: false,
      loading: false,
    };

    this.pararBusca = this.pararBusca.bind(this);
  }

  componentDidMount = async () => {
    await this.props.findCondominioById(this.props.match.params.condominioId);
    await this.props.findUnidadeByCondominioId(this.props.match.params.condominioId);
    await this.props.findById(this.props.match.params.id);

    this.setState({
      notificacao: {
        ...this.props.notificacao,
        unidades: this.props.notificacao.unidades.length > 0 ? this.props.notificacao.unidades : [],
        usuario: this.props.notificacao.usuario ? this.props.notificacao.usuario._id : null,
      },
      errors: {
        ...this.props.errorsCondominio,
        ...this.props.erros
      }
    })
  };

  pararBusca = () => {
    clearTimeout(this.state.busca);
  }

  validate = notificacao => {
    const errors = {}

    if (FormValidator.isVazio(notificacao.tipo)) {
      errors.tipo = 'Tipo é obrigatório';
    }

    if (!FormValidator.isVazio(notificacao.link) && !FormValidator.isUrl(notificacao.link)) {
      errors.link = 'Url inválida';
    }

    if (FormValidator.isVazio(notificacao.mensagem) && !this.state.file) {
      errors.mensagem = 'Adicione uma mensagem ou arquivo';
    }

    return errors;
  }

  onChangeFile = e => {
    const mime = ['application/pdf'];
    if (e.target.files && e.target.files[0]) {
      const type = e.target.files[0].type;
      if (mime.indexOf(type) !== -1 || type.substr(0, 5) === 'image') {
        if (FormValidator.sizeLimit(e.target.files[0], process.env.REACT_APP_LIMIT_UPLOAD)) {
          this.setState({
            file: e.target.files[0],
            errors: {},
          });
        } else {
          this.setState({
            errors: {
              arquivo: `Permitido arquivos de até ${process.env.REACT_APP_LIMIT_UPLOAD}mb`
            }
          });
        }
      }
    }
  }

  onChangeSelect = (_, { name, value }) =>
    this.setState({
      notificacao: { ...this.state.notificacao, [name]: value },
      errors: {}
    })

  onChange = e =>
    this.setState({
      notificacao: { ...this.state.notificacao, [e.target.name]: e.target.value },
      errors: {}
    })

  getTipos = () => [
    { key: 'DEFAULT', value: 'DEFAULT', text: 'Padrão' },
    { key: 'CONVOCATION', value: 'CONVOCATION', text: 'Convocação' },
  ]

  getUnidades = unidades =>
    unidades.map(unidade => ({
      key: unidade._id,
      value: unidade._id,
      text: `${unidade.bloco} ${unidade.numero}`,
    }))

  fileUpload = file => {
    const formData = new FormData();
    formData.append('arquivo', file);
    Object.keys(this.state.notificacao).filter(key => key !== 'arquivo').forEach(item => {
      formData.append(item, this.state.notificacao[item]);
    });
    return formData;
  }

  onSubmitEditar = async e => {
    e.preventDefault();
    const errors = this.validate(this.state.notificacao);
    this.setState({ errors });

    if (FormValidator.objIsEmpty(errors)) {
      this.setState({ loading: true });
      await this.props.findByIdAndUpdate(this.state.notificacao._id, this.fileUpload(this.state.file));
      this.setState({
        loading: false,
        sucesso: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors
      });
    }
  }

  render() {
    const { notificacao, errors, loading, sucesso, file } = this.state;
    const { condominio, unidades } = this.props;

    const voltar = `/condominios/${condominio._id || this.props.match.params.condominioId}/notificacoes`;

    return (
      <div>
        {!!errors.global && <Redirect to="/" />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} loading={loading} />
          <div className="va-imp-pagina">
            <CabecalhoForm voltar={voltar} voltarTexto="Convocação digital" titulo="Editar notificação" descricao="Altere a mensagem, o anexo ou os destinatários desta notificação." />
            {!!errors.error && <Erro text={errors.error} tipo="block" />}
            {sucesso && (
              <div className="va-res-banner sucesso" role="status">
                <Icon name="check circle outline" size="big" />
                <div>
                  <b>Notificação atualizada com sucesso</b>
                  <div className="va-res-acoes">
                    <Link to={voltar} className="ui button btn-ui-1 small"><Icon name="bell" /> Voltar para as notificações</Link>
                  </div>
                </div>
              </div>
            )}
            {!sucesso && (
              <Form onSubmit={this.onSubmitEditar} loading={loading} autoComplete="off" className="va-imp">
                <CamposNotificacao
                  notificacao={notificacao}
                  file={file}
                  errors={errors}
                  tipos={this.getTipos()}
                  unidadesOpcoes={this.getUnidades(unidades)}
                  arquivoAtualUrl={notificacao.arquivo && notificacao.arquivo.url}
                  modeloUrl={null}
                  onChange={this.onChange}
                  onChangeSelect={this.onChangeSelect}
                  onChangeFile={this.onChangeFile}
                />
                <RodapeForm>
                  <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                    <Icon name="save" /> Salvar alterações
                  </Button>
                  <Link to={voltar} className="ui basic large button">Cancelar</Link>
                </RodapeForm>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  notificacao: state.notificacao.notificacao,
  errors: state.notificacao.errors,
  condominio: state.condominio.condominio,
  unidades: state.unidade.unidades,
  errorsCondominio: state.condominio.errors
});

const mapDispatchToProps = dispatch => bindActionCreators({
  findCondominioById,
  findUnidadeByCondominioId,
  findById,
  findByIdAndUpdate
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditarNotificacao);
